<script setup lang="ts">
import RegistrationWizard from '../components/auth/RegistrationWizard.vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const handleComplete = () => {
  router.push('/dashboard')
}

const handleSignIn = () => {
  router.push('/')
}
</script>

<template>
  <div class="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-gray-900 dark:to-gray-800 py-12 px-4">
    <div class="max-w-4xl mx-auto">
      <!-- Animated Header -->
      <div class="text-center mb-12 animate-fade-in">
        <h1 class="text-4xl font-bold text-gray-900 dark:text-white mb-4">
          Create Your Account
        </h1>
        <p class="text-lg text-gray-600 dark:text-gray-400">
          Join thousands of businesses already using our platform
        </p>
      </div>

      <!-- Registration Wizard with Animation -->
      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden animate-slide-up">
        <RegistrationWizard 
          @complete="handleComplete"
          @signin="handleSignIn"
        />
      </div>

      <!-- Decorative Elements -->
      <div class="absolute top-20 left-10 w-20 h-20 bg-blue-500/10 rounded-full animate-float"></div>
      <div class="absolute bottom-20 right-10 w-32 h-32 bg-indigo-500/10 rounded-full animate-float-delayed"></div>
    </div>
  </div>
</template>

<style scoped>
.animate-fade-in {
  animation: fadeIn 1s ease-out;
}

.animate-slide-up {
  animation: slideUp 0.8s ease-out;
}

.animate-float {
  animation: float 6s ease-in-out infinite;
}

.animate-float-delayed {
  animation: float 6s ease-in-out 1s infinite;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}
</style>